import React from "react";
import { Translate } from "react-redux-i18n";
import {
  FaMapMarkerAlt,
  FaCity,
  FaMailBulk,
  FaPhoneAlt,
} from "react-icons/fa";
import Modal from "./Modal";
import "./styles/ModalTransactionAddress.css";

function ModalTransactionAddress({ isOpen, onClose, address }) {
  const cityState = address
    ? [address.City && address.City.Name, address.State && address.State.Name]
        .filter((v) => v && String(v).trim())
        .join(", ")
    : "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="transaction_address_title" />}
    >
      <div className="transaction-address-modal">
        {!address ? (
          <p className="transaction-address-modal__empty">
            <FaMapMarkerAlt />
            <Translate value="transaction_address_empty" />
          </p>
        ) : (
          <div className="transaction-address-modal__card">
            {address.Name ? (
              <span className="transaction-address-modal__name">
                {address.Name}
              </span>
            ) : null}

            <div className="transaction-address-modal__row">
              <FaMapMarkerAlt />
              <span>
                {address.Address1 || (
                  <Translate value="address_incomplete" />
                )}
                {address.Address2 ? `, ${address.Address2}` : ""}
              </span>
            </div>

            {cityState ? (
              <div className="transaction-address-modal__row">
                <FaCity />
                <span>{cityState}</span>
              </div>
            ) : null}

            {address.Zipcode ? (
              <div className="transaction-address-modal__row">
                <FaMailBulk />
                <span>{address.Zipcode}</span>
              </div>
            ) : null}

            {address.Phone ? (
              <div className="transaction-address-modal__row">
                <FaPhoneAlt />
                <span>{address.Phone}</span>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ModalTransactionAddress;
